import { applyMiddleware, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import { AuthState } from './ducks/auth/types';
import { InitialDeliveryEvents } from './ducks/deliveryEvents/types';
import { AuthStateDistributor } from './ducks/distributor/types';
import { InitialDistributorUser } from './ducks/distributorUser/types';
import { InitialDriver } from './ducks/driver/types';
import { Deliveries, InitialImportFile } from './ducks/freight/types';
import { InitialMappingData } from './ducks/mapping/types';
import { InitialReasonRefusal } from './ducks/reasonRefusal/types';
import persistedReducers from './ducks/reduxPersist';
import rootReducer from './ducks/rootReducer';
import rootSaga from './ducks/rootSaga';
import { TablesState } from './ducks/tables/types';
import { UserState } from './ducks/user/types';
import { InitialVehicleType } from './ducks/vehicleType/types';

export interface ApplicationState {
  user: UserState;
  auth: AuthState;
  tables: TablesState;
  distributor: AuthStateDistributor;
  freight: InitialImportFile;
  mapping: InitialMappingData;
  driver: InitialDriver;
  vehicleType: InitialVehicleType;
  reasonRefusal: InitialReasonRefusal;
  distributorUser: InitialDistributorUser;
  deliveries: Deliveries;
  deliveryEvents: InitialDeliveryEvents[];
}

const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  persistedReducers(rootReducer),
  applyMiddleware(sagaMiddleware),
);

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);

export default store;
